const pagination = (data, pagination_size, page) => {
  return data.slice( (page-1) * pagination_size, page * pagination_size );
}

export default pagination;
